import React from 'react';
import {
  PieChart, Pie, Cell, Tooltip, ResponsiveContainer,
} from 'recharts';

const COLORS = ['#B3C100', '#1F3F49', '#EA6A47', '#6AB187', '#488A99', '#DBAE58', '#0091D5', '#8D6E63', '#26A69A'];

type StatusTransition = {
  from_status: string;
  to_status: string;
  transition_rate: string; // "25.00%", "0.00%", "NaN%", etc.
};

type CasePieChartProps = {
  pieData?: StatusTransition[];
};

const CaseBookPieChart: React.FC<CasePieChartProps> = ({ pieData = [] }) => {
  const chartData = pieData
    .map(item => {
      const value = parseFloat(item.transition_rate);
      return {
        name: `${item.from_status} → ${item.to_status}`,
        value: isNaN(value) ? 0 : value,
      };
    });

  const allZero = chartData.every(item => item.value === 0);

  const finalChartData = allZero
    ? [{ name: 'No Transition Data', value: 1 }]
    : chartData.filter(item => item.value > 0);

  return (
    <div style={{ width: '100%', height: 300 }}>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={finalChartData}
            cx="50%"
            cy="50%"
            outerRadius={100}
            dataKey="value"
            label={({ name, percent }) =>
              name === 'No Transition Data'
                ? name
                : `${name} ${(percent * 100).toFixed(0)}%`
            }
          >
            {finalChartData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={entry.name === 'No Transition Data' ? '#ccc' : COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip
            formatter={(value: number, name: string) =>
              name === 'No Transition Data' ? '0%' : `${value.toFixed(2)}%`
            }
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CaseBookPieChart;
